import { Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import {
  edsn_Marktrol,
  RegistrationCreateDto,
} from "../../openapi/edsn-webapi";
import { safePropertyMap } from "../../utils";
import { DateControl, InputControl } from "../common";
import ProductBspSelectControl from "./ProductBspSelectControl";

const BSPDetails = () => {
  const map = safePropertyMap<RegistrationCreateDto>();
  const { watch } = useFormContext<RegistrationCreateDto>();
  const marketRole = watch("marketRole")!;

  const BSP = marketRole === edsn_Marktrol.BSPBALANCING_SERVICE_PROVIDER;

  if (BSP) {
    return (
      <>
        <Typography variant="h6" color="secondary">
          <FormattedMessage id="products" />
        </Typography>
        <ProductBspSelectControl
          required
          name={map("bspProducts")}
          label="product"
        />

        <Typography variant="h6" color="secondary">
          <FormattedMessage id="recognition" />
        </Typography>
        <InputControl name={map("nameBspInRegister")} label="nameBSP" />
        <DateControl
          name={map("recognitionStartDateBsp")}
          label="startdateRecog"
        />
      </>
    );
  }
  return null;
};

export default BSPDetails;
